<template>
    <div id="pop-up-wrapper" class="wrapperPopUp">
        <q-card v-for="(mutation, i) in mutations" class="selected" :key="'mutation'+i">
            <q-card-section class="q-card__section--rouge">
                <p class="num">
                    <span>{{ i + 1 }}</span>
                </p>
                <span class="name">
                    {{ mutation.properties ? getMutationType(mutation) : mutation.type }} -
                    {{ formatNumber(mutation.properties ? mutation.properties.sbati : mutation.sbati, 0)}} m² -
                    {{ formatNumber(mutation.properties ? mutation.properties.valeurfonc : mutation.valeurfonc, 0)}} €
                </span>
            </q-card-section>
        </q-card>
        <q-card v-for="(programme, i) in progs" class="selected leaflet-container" :key="'prog'+i">
            <q-card-section style="height:100%">
                <p class="num">
                    <span>{{ i + 1 }}</span>
                </p>
                <span class="name">{{ programme.nom }}</span>
                <p v-if="programme.promoteur">{{ programme.promoteur }}</p>
                <p>
                    <span v-if="programme.stock_initial">
                        {{ programme.stock_initial }} log{{ programme.stock_initial > 1 ? "s" : "" }}
                    </span>

                    <span v-if="programme.forme_urbaine">
                        - {{ programme.forme_urbaine == "INDIVIDUEL" ? "indi." : "coll." }}
                    </span>
                    <span v-if="programme.surface_moyenne">
                        - SHAB moy : {{ Math.round(parseFloat(programme.surface_moyenne.replace(",", "."))) }} m²
                    </span>
                </p>
                <p>
                    <span v-if="programme.vente_mois">
                        {{
                                new Intl.NumberFormat("fr-FR").format(
                                    programme.vente_mois.replace(",", ".")
                                )
                        }}
                        vente{{
                                Math.trunc(
                                    Math.abs(
                                        parseFloat(
                                            programme.vente_mois.replace(",", ".")
                                        )
                                    )
                                ) > 1
                                    ? "s"
                                    : ""
                        }} par mois
                    </span>
                    <span v-if="programme.date_commercialisation">
                        - mise en vente : {{ programme.date_commercialisation | filter_format_date }}
                    </span>
                </p>
				<p v-if="programme.prix_m2 && programme.prog_type">
                    prix tva pleine libre {{
                            new Intl.NumberFormat("fr-FR").format(
                                programme.prix_m2.replace(",", ".")
                            )
                    }}€{{ programme.forme_urbaine == 'INDIVIDUEL' ? '' : '/m²' }}
                    <strong><u>{{ programme.forme_urbaine == 'INDIVIDUEL' ? 'avec' : 'hors' }} stat.</u></strong>
                </p>
				<p v-else-if="programme.forme_urbaine == 'INDIVIDUEL'">
                    {{ getPrixPUMIntoSelectedCard(programme) }} € <strong><u>avec stat.</u></strong>
                </p>
                <div v-else>
					<p v-if="programme.tva_pleine_libre_prix_m2_parking_avec > 0">prix tva pleine libre {{ programme.tva_pleine_libre_prix_m2_parking_avec}} €/m²  <strong><u> avec stat</u></strong></p>
					<p v-if="programme.tva_pleine_libre_prix_m2_parking_sans > 0">prix tva pleine libre {{ programme.tva_pleine_libre_prix_m2_parking_sans}} €/m²  <strong><u> hors stat</u></strong></p>
				</div>
				<div  v-if="programme.typologies && programme.typologies.filter((typo)=>{return typo.nombre_logement != 0 && typo.nombre_logement != undefined}).length > 0">
					<p><u>Prix unitaires moyens ({{ programme.forme_urbaine == 'INDIVIDUEL' ? 'avec stat' : 'hors stat' }})</u> : </p>
					<p v-for="typologie in programme.typologies.filter((typo)=>{return typo.nombre_logement != 0 && typo.nombre_logement != undefined})" :key="programme.id + '_' + typologie.typologie">
						{{  typologieText(typologie) }}
					</p>
				</div>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>

import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

import number from "@/libs/number";
import MapMixin from "@/components/study/editor/elements/cartographie/map.mixin.js";

export default {
	name: "PopUpWrapper",
	mixins: [ MapMixin ],
	props: {
		selected_mutations: {
			default: [],
		},
		selected_markers: {
			default: [],
		},
		hard_coded_programs: {
			default: [],
		},
		selected_programs: {
			default: [],
		}
	},
	filters: {
		filter_format_date: function (value) {
			const format = value.includes("/") ? "YYYY/MM" : "YYYYMMDD";
			return moment(value, format).format("MMM YY");
		}
	},
	computed: {
		progs (){
			const progsList = [...this.selected_programs, ...this.hard_coded_programs.filter((hc) => hc.prog_type == "prog")];
			
			return progsList.filter(function (element) {
				return element !== undefined;
			});
		},
		mutations (){
			const mutationsList = [...this.selected_mutations, ...this.hard_coded_programs.filter(hc => hc.prog_type == "vente")];
			return mutationsList.filter(function (element) {
				return element !== undefined;
			});
		},
		typologieText (){
			return (typologie) => {
				const name = typologie.typologie.toUpperCase();
				const nb_log = typologie.nombre_logement;
				const surf_moy = typologie.surface_moyenne;
				const PUM = Math.floor(typologie.prix_unitaire_moyen / 1000);
				return `${name} (${nb_log} logs - ${surf_moy}m²) : ${PUM}K€;`;};
		}
	},
	methods: {
		getPrixPUMIntoSelectedCard: function (data) {
			const prix_aide = data.pum_tva_pleine_aide;
			const prix_libre = data.pum_tva_pleine_libre;
			const prix_reduit = data.pum_tva_reduite;
			let result = "";

			if (prix_libre > 0) {
				result = "prix tva pleine libre ".concat(prix_libre);
			} else if (prix_aide > 0) {
				result = "prix tva pleine aidé ".concat(prix_aide);
			} else {
				result = "prix tva réduite ".concat(prix_reduit);
			}

			//var result = "prix tva reduite : 0.0 €"
			return result;
		},
		formatNumber (value, decimals) {
			return number.format(value, decimals);
		},
	}
};
</script>
<style lang="stylus" scoped>
.wrapperPopUp{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 10px;
    grid-auto-flow:row;
}

#pop-up-wrapper{
	.selected {
		z-index: 100000;
		.name {
			font-weight: bold;
			font-size: 12px;
		}
		p {
			font-size: 10px;
		}
		.q-card__section--vert {
			padding: 4px !important;
			background-color: #e0ebe9;
		}
		.q-card__section--rouge {
			padding: 4px !important;
			background-color: #edd5d5;
		}
	}
	p.num {
		top: -3px;
		left: -3px;
		display: inline-block;
		margin-right : 3px;
		background: #3e5d58;
		color: white;
		width: 18px !important;
		height: 18px !important;
		text-align: center;
		border-radius: 12px;
		font-size: 12px;

		span {
			position: relative;
			bottom: 1%;
		}
	}
}
</style>